import { parseEther } from "viem";

export const appEnv = import.meta.env.VITE_APP_ENV || "development";

export const walletConnectProjectId =
  import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID ||
  "feff2e9ec8ed3ed3a2f5a000e1ec9347";

export const wssUrl = import.meta.env.VITE_WSS_URL || "";

export const rpcURL = import.meta.env.VITE_APP_RPC_URL || "";

export const isProduction = appEnv === "production";

export const isDevelopment = appEnv === "development";

export const isBeta = appEnv === "beta";
// 合约地址
export const FORTTRADE_CONTRACT_ADDRESS =
  import.meta.env.VITE_FORTTRADE_CONTRACT_ADDRESS || "";
export const USDT_ADDRESS = import.meta.env.VITE_USDT_ADDRESS || "";
export const FUSD_BUY_CONTRACT_ADDRESS =
  import.meta.env.VITE_FUSD_BUY_CONTRACT_ADDRESS || "";
export const PAYMENT_GATEWAY_CONTRACT_ADDRESS =
  import.meta.env.VITE_PAYMENT_GATEWAY_CONTRACT_ADDRESS || "";
export const WITHDRAW_PROXY_CONTRACT_ADDRESS =
  import.meta.env.VITE_WITHDRAW_PROXY_CONTRACT_ADDRESS || "";
export const CCC_USDT_ADDRESS = import.meta.env.VITE_CCC_USDT_ADDRESS || "";
export const CCC_FUSD_ADDRESS = import.meta.env.VITE_CCC_FUSD_ADDRESS || "";
export const CCC_AIF_ADDRESS = import.meta.env.VITE_CCC_AIF_ADDRESS || "";
export const BUY_FUSD_BRI_CONTRACT_ADDRESS =
  import.meta.env.VITE_BUY_FUSD_BRI_CONTRACT_ADDRESS || "";
export const FORT_TSK_VAULT_CONTRACT_ADDRESS =
  import.meta.env.VITE_FORT_TSK_VAULT_CONTRACT_ADDRESS || "";
export const BNB_FEE = parseEther(import.meta.env.VITE_BNB_FEE || "0");
export const CCC_GAS_CHECK = parseEther("0.0007");
